/* Grondyke · keeps the footer's sticky-bar reserve equal to the bar's real height.

   The reserve was a hardcoded guess per breakpoint, which is fragile: the v1 result page's
   mobile bar measured 130px against a 132px reserve, so one extra line of copy in the product
   name or the meta line would have pushed the bar over the footer. That bar is two rows on
   mobile by design (the CTA goes full width), so its height genuinely depends on its copy.

   This publishes the measured height as --gk-sticky-h and the stylesheets add their own
   breathing room. The CSS keeps the old numbers as var() fallbacks, so with no JS the pages
   behave exactly as before. */
(function () {
  if (window.GKStickyReserve) return;
  window.GKStickyReserve = true;

  var SEL = '.gk-qr__sticky, .gk-pr-sticky, .gk-cr-sticky, .gk-ds-sticky, .gk-ss-sticky';

  function apply() {
    var bar = document.querySelector(SEL);
    if (!bar) return;
    // translateY (the v2 bar hides itself that way) does not affect the measured height.
    var h = Math.ceil(bar.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--gk-sticky-h', h + 'px');
  }

  function init() {
    var bar = document.querySelector(SEL);
    if (!bar) return;
    apply();
    if (window.ResizeObserver) { new ResizeObserver(apply).observe(bar); }
    window.addEventListener('resize', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
